import React from 'react';

function ComplexityControls({ level, setLevel }) {
  const complexityLevels = {
    1: {
      label: "Child-friendly (5 years old)",
      description: "Simple words, short sentences, concrete examples, and colorful metaphors."
    },
    2: {
      label: "Elementary (10 years old)",
      description: "Basic concepts, longer sentences, some technical terms with explanations."
    },
    3: {
      label: "High School (16 years old)",
      description: "More technical terms, abstract concepts, and detailed examples."
    },
    4: {
      label: "College Level",
      description: "Advanced concepts, field-specific terminology, and theoretical frameworks."
    },
    5: {
      label: "Expert Level",
      description: "Full technical vocabulary, nuanced analysis, and specialized knowledge."
    }
  };

  return (
    <div className="modern-complexity-controls">
      <div className="slider-header">
        <span className="slider-title">Complexity Level</span>
        <span className="current-level">{complexityLevels[level].label}</span>
      </div>
      <div className="modern-slider-container">
        <input 
          type="range" 
          className="modern-slider" 
        //   id="complexity-slider" 
          min="1" 
          max="5" 
          value={level}
          onChange={(e) => setLevel(parseInt(e.target.value))}
        />
      </div>
      <div className="slider-labels">
        <span>Simple</span>
        <span>Complex</span>
      </div>
      <div className="complexity-labels">
        <span id="complexity-label">Current: {complexityLevels[level].label}</span>
        <p className="complexity-description">{complexityLevels[level].description}</p>
      </div>
    </div>
  );
}

export default ComplexityControls;